import { OpenButton } from "@/utilities/types/streaming";


export function generateUpdateCameraAndButton(cameraId: number, currentCameraId:number, setCurrentCameraId: React.Dispatch<React.SetStateAction<number>>, setButtonState: React.Dispatch<React.SetStateAction<OpenButton>> ) {
    return () => {
      if (cameraId !== currentCameraId) {
        setCurrentCameraId(cameraId);
        setButtonState(OpenButton.None);
      }
    };
}
